let accessToken;

const getParameterByName = (name) => {
  name = name.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\#&]' + name + '=([^&#]*)');
  const results = regex.exec(window.location.hash);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export async function getToken() {
  const hostname = window.location.hostname;
  const pathName = window.location.pathname;
  var CLIENT_ID, ENVIRONMENT, redirect_uri, region, dataTableId;

  console.log(hostname);
  console.log(pathName);

  switch (`${hostname}${pathName}`) {
    case 'localhost/':
      CLIENT_ID = '57385183-bcca-4cce-abd5-a45aad626a1c';
      ENVIRONMENT = 'sae1.pure.cloud';
      redirect_uri = `http://localhost:3000/OncoClinicas`;
      region = 'api';
      break;

    case 'token.kdash.com.br/LeroyMerlin':
      CLIENT_ID = '1a71ad3a-5ba4-4656-baed-ef2f8e316e61';
      ENVIRONMENT = 'mypurecloud.com';
      redirect_uri = 'https://token.kdash.com.br/LeroyMerlin';
      region = 'api';
      dataTableId = 'df7aabf1-74a1-4614-85f4-acf30b81da38';
      break;

    case 'localhost/LeroyMerlin':
      CLIENT_ID = '1a71ad3a-5ba4-4656-baed-ef2f8e316e61';
      ENVIRONMENT = 'mypurecloud.com';
      redirect_uri = 'http://localhost:3000/LeroyMerlin';
      region = 'api';
      dataTableId = 'df7aabf1-74a1-4614-85f4-acf30b81da38';
      break;

    case 'token.kdash.com.br/OncoClinicas':
      CLIENT_ID = '57385183-bcca-4cce-abd5-a45aad626a1c';
      ENVIRONMENT = 'sae1.pure.cloud';
      redirect_uri = `https://token.kdash.com.br/OncoClinicas`;
      region = 'api';
      dataTableId = 'dafa6ae5-14ef-4bb1-adbe-ed9dd75aa349';
      break;

    case 'localhost/OncoClinicas':
      CLIENT_ID = '57385183-bcca-4cce-abd5-a45aad626a1c';
      ENVIRONMENT = 'sae1.pure.cloud';
      redirect_uri = `http://localhost:3000/OncoClinicas`;
      region = 'api';
      dataTableId = 'dafa6ae5-14ef-4bb1-adbe-ed9dd75aa349';
      break;

    default:
      console.log('Default');

      break;
  }

  if (window.location.hash) {
    accessToken = getParameterByName('access_token');

    // Clear hash from URL after processing
    window.location.hash = '';
  } else {
    // If no hash, initiate OAuth authorization flow
    const queryStringData = {
      response_type: 'token',
      client_id: CLIENT_ID,
      redirect_uri: redirect_uri,
    };

    const url = `https://login.${ENVIRONMENT}/oauth/authorize?${new URLSearchParams(
      queryStringData
    ).toString()}`;

    window.location.replace(url);
  }

  return {
    accessToken: accessToken,
    environment: ENVIRONMENT,
    dataTableId: dataTableId,
  };
}
